module.exports = ".footer{\n    background: #99ffff;/* #17a2b8;*/\n    color: rgb(146, 136, 136);\n}\n.footer a{\n    color: rgb(21, 32, 34);\n    \n}\n"